/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Intro_List_11Inputs */

const en_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus 60 minutes each day to earn a free cake box.`)
};

const ar_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ركز لمدة 60 دقيقة كل يوم لتربح صندوق كعك مجاني.`)
};

const de_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokussiere dich jeden Tag 60 Minuten lang, um eine kostenlose Kuchenbox zu erhalten.`)
};

const es_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concéntrate 60 minutos al día para ganar una caja de pasteles gratis.`)
};

const fr_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrez-vous 60 minutes par jour pour gagner une boîte à gâteaux gratuite.`)
};

const it_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrati 60 minuti ogni giorno per ottenere una scatola di torte gratuita.`)
};

const ja_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日60分間集中して、無料のケーキボックスを獲得しましょう。`)
};

const ko_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 60분씩 집중하여 무료 케이크 상자를 획득하세요.`)
};

const pt_br_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentre-se 60 minutos todos os dias para ganhar uma caixa de bolo grátis.`)
};

const ru_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фокусируйтесь 60 минут каждый день, чтобы получить бесплатную коробку с тортом.`)
};

const th_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัส 60 นาทีทุกวันเพื่อรับกล่องเค้กฟรี`)
};

const tr_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz bir pasta kutusu kazanmak için her gün 60 dakika odaklanın.`)
};

const zh_cn_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天专注 60 分钟，即可免费获得一个蛋糕礼盒。`)
};

const zh_tw_bakery_intro_list_11 = /** @type {(inputs: Bakery_Intro_List_11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天專注 60 分鐘，即可免費獲得一個蛋糕禮盒。`)
};

/**
* | output |
* | --- |
* | "Focus 60 minutes each day to earn a free cake box." |
*
* @param {Bakery_Intro_List_11Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const bakery_intro_list_11 = /** @type {((inputs?: Bakery_Intro_List_11Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Intro_List_11Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_intro_list_11(inputs)
	if (locale === "ar") return ar_bakery_intro_list_11(inputs)
	if (locale === "de") return de_bakery_intro_list_11(inputs)
	if (locale === "es") return es_bakery_intro_list_11(inputs)
	if (locale === "fr") return fr_bakery_intro_list_11(inputs)
	if (locale === "it") return it_bakery_intro_list_11(inputs)
	if (locale === "ja") return ja_bakery_intro_list_11(inputs)
	if (locale === "ko") return ko_bakery_intro_list_11(inputs)
	if (locale === "pt_br") return pt_br_bakery_intro_list_11(inputs)
	if (locale === "ru") return ru_bakery_intro_list_11(inputs)
	if (locale === "th") return th_bakery_intro_list_11(inputs)
	if (locale === "tr") return tr_bakery_intro_list_11(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_intro_list_11(inputs)
	return zh_tw_bakery_intro_list_11(inputs)
});
export { bakery_intro_list_11 as "Bakery_intro_list_1" }